import PresupuestosConfiguracion from "./PresupuestosConfiguracion";
export default PresupuestosConfiguracion;